const STORAGE_PREFIX = 'helpdesk_ticket_seen_v1'

function storageKey(userId) {
  return `${STORAGE_PREFIX}:${userId || 'guest'}`
}

function readMap(userId) {
  try {
    const raw = localStorage.getItem(storageKey(userId))
    if (!raw) {
      return {}
    }
    const parsed = JSON.parse(raw)
    return parsed && typeof parsed === 'object' ? parsed : {}
  } catch (e) {
    return {}
  }
}

function writeMap(userId, map) {
  try {
    localStorage.setItem(storageKey(userId), JSON.stringify(map || {}))
  } catch (e) {
    // ignore quota / private mode
  }
}

export function getTicketSeenAt(userId, ticketId) {
  const map = readMap(userId)
  return map[String(ticketId)] || null
}

export function markTicketSeen(userId, ticketId, seenAt) {
  if (!ticketId) {
    return
  }
  const map = readMap(userId)
  const stamp = seenAt || new Date().toISOString().slice(0, 19).replace('T', ' ')
  map[String(ticketId)] = stamp
  writeMap(userId, map)
}

export function isTicketUnread(ticket, userId) {
  if (!ticket || !ticket.has_reply || !ticket.last_reply_at) {
    return false
  }
  const seenAt = getTicketSeenAt(userId, ticket.id)
  if (!seenAt) {
    return true
  }
  return String(ticket.last_reply_at) > String(seenAt)
}

export function countUnreadTickets(tickets, userId) {
  if (!Array.isArray(tickets)) {
    return 0
  }
  return tickets.reduce((total, ticket) => total + (isTicketUnread(ticket, userId) ? 1 : 0), 0)
}
